import { LegalLayout, LegalSection } from './legal-layout';

/* Politique de confidentialité (art. 12-14 RGPD). Contenu v1 dérivé du modèle
   validé avec Naïa ; à finaliser par un juriste. Modèle : établissement =
   responsable de traitement, Naïa = sous-traitant. */
export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Politique de confidentialité" updated="30 août 2026" seeAlso={{ to: '/cgu', label: "conditions d'utilisation" }}>
      <p>
        Naïa propose un assistant pédagogique fondé sur l'intelligence artificielle, utilisé dans le
        cadre scolaire. Cette politique explique quelles données sont traitées, pourquoi, combien de
        temps, et quels sont vos droits.
      </p>

      <LegalSection heading="Qui est responsable de vos données ?">
        <p>
          Dans le cadre scolaire, l'établissement qui inscrit les élèves et les enseignants est
          <strong> responsable de traitement</strong>. Naïa agit comme <strong>sous-traitant</strong>,
          pour le compte et sur instruction de l'établissement. Pour toute demande, adressez-vous
          d'abord à votre établissement.
        </p>
      </LegalSection>

      <LegalSection heading="Quelles données sont traitées ?">
        <ul className="list-disc pl-5 flex flex-col gap-1">
          <li>Identité : nom, prénom, adresse e-mail, rôle, classe ou niveau.</li>
          <li>Contenus : conversations avec l'assistant, images de copies soumises à la correction.</li>
          <li>Usage : données techniques nécessaires au fonctionnement du service.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Pourquoi ?">
        <p>
          Fournir le tutorat de l'élève, l'aide à la correction et l'assistance à l'enseignant. Les
          données ne sont jamais utilisées à des fins commerciales, ne sont pas revendues, et ne
          servent pas à entraîner des modèles d'IA.
        </p>
      </LegalSection>

      <LegalSection heading="Une intelligence artificielle">
        <p>
          Les réponses sont générées par une IA et peuvent comporter des erreurs : les informations
          importantes doivent être vérifiées. L'assistant n'est pas un humain et ne remplace ni un
          adulte, ni un professionnel.
        </p>
      </LegalSection>

      <LegalSection heading="Le chat de l'élève">
        <p>
          Le chat de l'élève est activé par le responsable légal, qui peut lire les conversations.
          L'enfant en est informé dans l'interface. Sur un sujet sensible, l'assistant renvoie vers
          un adulte et vers les numéros d'aide (3018, 119).
        </p>
      </LegalSection>

      <LegalSection heading="Combien de temps ?">
        <ul className="list-disc pl-5 flex flex-col gap-1">
          <li>Conversations du chat élève : 12 mois.</li>
          <li>Images de copies : fin de l'année scolaire en cours.</li>
          <li>Comptes inactifs : 24 mois.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Où sont hébergées vos données ?">
        <p>
          Dans l'Union européenne. Certains prestataires techniques appartiennent à des groupes hors
          UE ; les transferts éventuels sont encadrés par des garanties conformes au RGPD (clauses
          contractuelles types, Data Privacy Framework).
        </p>
      </LegalSection>

      <LegalSection heading="Vos droits">
        <p>
          Vous disposez des droits d'accès, de rectification, d'effacement, de limitation,
          d'opposition et de portabilité. Pour les exercer, contactez votre établissement
          (responsable de traitement). Vous pouvez aussi saisir la CNIL (
          <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-naia-blue underline inline-block py-3">www.cnil.fr</a>).
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Pour toute question relative à cette politique, écrivez à{' '}
          <a href="mailto:rgpd@naia-edu.com" className="text-naia-blue underline inline-block py-3">rgpd@naia-edu.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
